// extracted by mini-css-extract-plugin
module.exports = {"selectedTaskSidebar":"SelectedTaskSidebar_selectedTaskSidebar__1kVUj","opened":"SelectedTaskSidebar_opened__uBLLW","closeBtn":"SelectedTaskSidebar_closeBtn__2I-3R"};